module.exports = __webpack_public_path__ + "img/login-v2-dark.12eb0ac5.svg";